import Head from 'next/head';
import Host from '../src/legacy/components/pages/Host/Host';
import { NextRouter } from 'next/router';

interface HostPageProps {
  router: NextRouter;
}

export const HostPage = ({ router }: HostPageProps): JSX.Element => (
    <div className="container mx-auto">
      <Head>
        <title>Host | Bounce</title>
      </Head>

      <Host router={router} />
    </div>
  );

export async function getStaticProps() {
  return {
    props: {} // will be passed to the page component as props
  };
}

export default HostPage;
